const header_menu_button = document.querySelector(".header-menu");
const header_nav = document.querySelector(".header-nav");

header_menu_button.addEventListener("click", function () {
    header_nav.classList.toggle("open");
});

window.addEventListener("click", function (e) {
    if (
        !header_nav.contains(e.target) &&
        !header_menu_button.contains(e.target)
    ) {
        // Ниже код, который нужно выполнить при срабатывании события.
        header_nav.classList.remove("open");
    }
});
